module.exports = __webpack_public_path__ + "img/cate-3-1940d7.png";